import Api from "./api";

export const getFileByBucketKey = async (hirerid, buketkey) => {
    let data = [];
    await Api.get(`/llmdocument/file/${hirerid}?path=${buketkey}`)
      .then((result) => {
        data = result
      })
      .catch((err) => {
        data = err
      });
    return data
  }